import { NotifyEventData } from '@/shared/components/notifications'

export type PickupConnectedParty = {
  number: string
  name: string
}

const pendingByReplacesCallId = new Map<string, PickupConnectedParty>()

export const getConnectedPartyFromPickupEvent = (event: NotifyEventData): PickupConnectedParty | undefined => {
  const interceptNumber = event.interceptNumber || event.target
  const showCaller = event.from !== interceptNumber
  const number = showCaller ? event.from : event.target
  const name = showCaller ? event.fromName : event.targetName
  if (!number) {
    return undefined
  }
  return { number, name: name || number }
}

export const rememberPickupConnectedParty = (replacesCallId: string, party: PickupConnectedParty): void => {
  if (!replacesCallId || !party.number) {
    return
  }
  pendingByReplacesCallId.set(replacesCallId, party)
}

export const takePickupConnectedParty = (replacesCallId: string): PickupConnectedParty | undefined => {
  const party = pendingByReplacesCallId.get(replacesCallId)
  pendingByReplacesCallId.delete(replacesCallId)
  return party
}

export const forgetPickupConnectedParty = (replacesCallId: string): void => {
  if (!replacesCallId) {
    return
  }
  pendingByReplacesCallId.delete(replacesCallId)
}

export const forgetAllPickupConnectedParties = (): void => {
  pendingByReplacesCallId.clear()
}

/** Снимает сторону до remove() уведомления и возвращает её в кэш непосредственно перед INVITE. */
export const suspendPickupConnectedParty = (replacesCallId: string): (() => void) => {
  const party = takePickupConnectedParty(replacesCallId)
  return () => {
    if (party) {
      rememberPickupConnectedParty(replacesCallId, party)
    }
  }
}
